import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 3x5, 2 - 2x3',
  imageCount: 3,
  displayGroup: 'DG_3X5_WALLET',
  calc: (height) => {
    const p1Width = height / ASPECT_RATIO / 2;
    const p1Height = height / 2;
    const p3Height = (height * ASPECT_RATIO) / 2;

    return {
      gridTemplate: () => `
        'p1 p2 p3' ${p1Height}px
        '. . .' ${height / 2}px
        / ${p1Width}px ${p1Width}px ${p3Height}px`,
      photos: [
        ...gridPhotos(1, 2, p1Width, p1Height),
        {
          gridArea: 'p3',
          width: p1Height,
          height: p3Height,
          rotation: -90
        }
      ]
    };
  }
};
